(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._buttonWrap_m99s7_1{position:fixed;transform:translateY(-50%);pointer-events:all;inset-inline-end:0;inset-block-start:50%}._button_m99s7_1{display:flex;align-items:center;justify-content:center;width:32px;height:40px;padding:0;color:var(--uikit-decoration-new-red-10, #ffe9e5);background:var(--uikit-bg-c-negative, #d4083b);border:none;border-start-start-radius:4px;border-start-end-radius:0;border-end-start-radius:4px;border-end-end-radius:0;cursor:pointer}._button_m99s7_1:hover{background:var(--uikit-bg-c-negative-hovered, #96352f)}._button_m99s7_1:active{background:var(--uikit-bg-c-negative-pressed, #6c2c27)}._wrap_u3ra9_1{display:flex;flex-direction:column;width:100%;row-gap:12px}._title_u3ra9_8{font-family:Hauss,sans-serif;font-weight:500;font-size:1.375rem;line-height:1.75rem;letter-spacing:normal;margin:0}._gradesWrap_u3ra9_17{display:flex;align-items:center;margin-bottom:16px;padding:8px;background:var(--uikit-bg-c-default, #ffffff);border-radius:4px}._grade_u3ra9_17{display:grid;flex:1;grid-row-gap:8px;grid-template-rows:32px auto;align-items:flex-start;justify-content:center;padding:8px 0;background:none;border:none;border-radius:4px;cursor:pointer}._grade_u3ra9_17:hover{background:var(--uikit-bg-c-default-hovered, #efefef)}._grade_u3ra9_17:active{background:var(--uikit-bg-c-default-pressed, #d6d6d6)}._emoji_u3ra9_46{font-size:32px;line-height:1}._label_u3ra9_51{font-family:Hauss,sans-serif;font-weight:400;font-size:.875rem;line-height:1.25rem;letter-spacing:normal;text-align:center}._wrap_ssai0_1{position:relative;display:flex;flex-direction:column;flex-grow:1;row-gap:12px}._content_ssai0_9{display:flex;flex-direction:column;row-gap:12px;overflow:auto}._title_ssai0_16{font-family:Hauss,sans-serif;font-weight:500;font-size:1.375rem;line-height:1.75rem;letter-spacing:normal;margin:0}._commentWrap_ssai0_25{padding:12px 2px 0}._commentTitle_ssai0_30{font-family:Hauss,sans-serif;font-weight:500;font-size:1.125rem;line-height:1.5rem;letter-spacing:normal;margin-bottom:16px}._commentInput_ssai0_39{position:relative;display:flex;flex-direction:column}._commentCounter_ssai0_45{font-family:Hauss,sans-serif;font-weight:400;font-size:.75rem;line-height:1rem;letter-spacing:normal;margin-top:2px;color:var(--uikit-text-new-graphics-only, #808080)}html[dir=rtl] ._commentCounter_ssai0_45{display:flex;justify-content:flex-end;direction:ltr}._buttonsWrap_ssai0_60{display:grid;grid-auto-columns:1fr;grid-auto-flow:column;grid-column-gap:20px;margin-top:auto;padding-top:18px}._buttonsWrap_ssai0_60>button{padding:0 16px}._wrap_13myq_1{position:absolute;top:-1px;left:-1px;z-index:1;display:flex;flex-direction:column;align-items:center;justify-content:center;width:calc(100% + 2px);height:calc(100% + 2px);text-align:center;background:var(--floating-modal-background-color);row-gap:12px}._iconWrap_13myq_17{display:flex;justify-content:center;margin-bottom:12px;color:var(--uikit-text-new-success, #358730)}._title_13myq_24{font-family:Hauss,sans-serif;font-weight:500;font-size:1.375rem;line-height:1.75rem;letter-spacing:normal;margin:0}._text_13myq_33{font-weight:400;font-size:16px;line-height:24px}._buttonWrap_13myq_39{margin-top:12px}._wrap_de90h_1{--ui-floating-button-default-position-right: 0px;--ui-floating-button-default-position-bottom: 0px;--z-index: var(--ui-feedback-z-index, 1);--wrap-top: var(--ui-feedback-wrap-top, auto);--wrap-left: var(--ui-feedback-wrap-left, auto);--wrap-right: var(--ui-feedback-wrap-right, 0);--wrap-bottom: var(--ui-feedback-wrap-bottom, 0);--wrap-width: var(--ui-feedback-wrap-width, 100%);--wrap-height: var(--ui-feedback-wrap-height, 100%);position:fixed;inset:var(--wrap-top) var(--wrap-right) var(--wrap-bottom) var(--wrap-left);z-index:var(--z-index);width:var(--wrap-width);height:var(--wrap-height);pointer-events:none}._modal_de90h_19{pointer-events:all}._content_de90h_23{position:relative;display:flex;flex-grow:1;max-height:calc(100vh - 100px)}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import Ne, { useState as G } from "react";
import { Wrapper as Ae } from "@platform/ui-wrapper";
import { useTranslation as J, I18nextProvider as pr } from "react-i18next";
import { TextButton as ne } from "@platform/ui-buttons";
import { Checkbox as hr } from "@platform/ui-checkbox";
import { Textarea as _r } from "@platform/ui-input";
import { FloatingModal as kr } from "@platform/ui-modal";
var oe = { exports: {} }, I = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oe;
function gr() {
  if (Oe) return I;
  Oe = 1;
  var l = Ne, c = Symbol.for("react.element"), m = Symbol.for("react.fragment"), h = Object.prototype.hasOwnProperty, d = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, w = { key: !0, ref: !0, __self: !0, __source: !0 };
  function R(T, f, g) {
    var _, v = {}, E = null, j = null;
    g !== void 0 && (E = "" + g), f.key !== void 0 && (E = "" + f.key), f.ref !== void 0 && (j = f.ref);
    for (_ in f) h.call(f, _) && !w.hasOwnProperty(_) && (v[_] = f[_]);
    if (T && T.defaultProps) for (_ in f = T.defaultProps, f) v[_] === void 0 && (v[_] = f[_]);
    return { $$typeof: c, type: T, key: E, ref: j, props: v, _owner: d.current };
  }
  return I.Fragment = m, I.jsx = R, I.jsxs = R, I;
}
var B = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pe;
function yr() {
  return Pe || (Pe = 1, process.env.NODE_ENV !== "production" && function() {
    var l = Ne, c = Symbol.for("react.element"), m = Symbol.for("react.portal"), h = Symbol.for("react.fragment"), d = Symbol.for("react.strict_mode"), w = Symbol.for("react.profiler"), R = Symbol.for("react.provider"), T = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), _ = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), j = Symbol.for("react.offscreen"), M = Symbol.iterator, H = "@@iterator";
    function A(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = M && e[M] || e[H];
      return typeof r == "function" ? r : null;
    }
    var P = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          t[a - 1] = arguments[a];
        $e("error", e, t);
      }
    }
    function $e(e, r, t) {
      {
        var a = P.ReactDebugCurrentFrame, i = a.getStackAddendum();
        i !== "" && (r += "%s", t = t.concat([i]));
        var u = t.map(function(s) {
          return String(s);
        });
        u.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, u);
      }
    }
    var Ge = !1, Ie = !1, Be = !1, Ye = !1, Me = !1, se;
    se = Symbol.for("react.module.reference");
    function Le(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === h || e === w || Me || e === d || e === g || e === _ || Ye || e === j || Ge || Ie || Be || typeof e == "object" && e !== null && (e.$$typeof === E || e.$$typeof === v || e.$$typeof === R || e.$$typeof === T || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === se || e.getModuleId !== void 0));
    }
    function Ue(e, r, t) {
      var a = e.displayName;
      if (a)
        return a;
      var i = r.displayName || r.name || "";
      return i !== "" ? t + "(" + i + ")" : t;
    }
    function ie(e) {
      return e.displayName || "Context";
    }
    function S(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case h:
          return "Fragment";
        case m:
          return "Portal";
        case w:
          return "Profiler";
        case d:
          return "StrictMode";
        case g:
          return "Suspense";
        case _:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case T:
            var r = e;
            return ie(r) + ".Consumer";
          case R:
            var t = e;
            return ie(t._context) + ".Provider";
          case f:
            return Ue(e, e.render, "ForwardRef");
          case v:
            var a = e.displayName || null;
            return a !== null ? a : S(e.type) || "Memo";
          case E: {
            var i = e, u = i._payload, s = i._init;
            try {
              return S(s(u));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var O = Object.assign, $ = 0, ce, le, ue, fe, de, ve, be;
    function me() {
    }
    me.__reactDisabledLog = !0;
    function Ve() {
      {
        if ($ === 0) {
          ce = console.log, le = console.info, ue = console.warn, fe = console.error, de = console.group, ve = console.groupCollapsed, be = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: me,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        $++;
      }
    }
    function qe() {
      {
        if ($--, $ === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: O({}, e, {
              value: ce
            }),
            info: O({}, e, {
              value: le
            }),
            warn: O({}, e, {
              value: ue
            }),
            error: O({}, e, {
              value: fe
            }),
            group: O({}, e, {
              value: de
            }),
            groupCollapsed: O({}, e, {
              value: ve
            }),
            groupEnd: O({}, e, {
              value: be
            })
          });
        }
        $ < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var K = P.ReactCurrentDispatcher, X;
    function L(e, r, t) {
      {
        if (X === void 0)
          try {
            throw Error();
          } catch (i) {
            var a = i.stack.trim().match(/\n( *(at )?)/);
            X = a && a[1] || "";
          }
        return `
` + X + e;
      }
    }
    var Z = !1, U;
    {
      var ze = typeof WeakMap == "function" ? WeakMap : Map;
      U = new ze();
    }
    function pe(e, r) {
      if (!e || Z)
        return "";
      {
        var t = U.get(e);
        if (t !== void 0)
          return t;
      }
      var a;
      Z = !0;
      var i = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var u;
      u = K.current, K.current = null, Ve();
      try {
        if (r) {
          var s = function() {
            throw Error();
          };
          if (Object.defineProperty(s.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(s, []);
            } catch (F) {
              a = F;
            }
            Reflect.construct(e, [], s);
          } else {
            try {
              s.call();
            } catch (F) {
              a = F;
            }
            e.call(s.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (F) {
            a = F;
          }
          e();
        }
      } catch (F) {
        if (F && a && typeof F.stack == "string") {
          for (var o = F.stack.split(`
`), k = a.stack.split(`
`), b = o.length - 1, p = k.length - 1; b >= 1 && p >= 0 && o[b] !== k[p]; )
            p--;
          for (; b >= 1 && p >= 0; b--, p--)
            if (o[b] !== k[p]) {
              if (b !== 1 || p !== 1)
                do
                  if (b--, p--, p < 0 || o[b] !== k[p]) {
                    var x = `
` + o[b].replace(" at new ", " at ");
                    return e.displayName && x.includes("<anonymous>") && (x = x.replace("<anonymous>", e.displayName)), typeof e == "function" && U.set(e, x), x;
                  }
                while (b >= 1 && p >= 0);
              break;
            }
        }
      } finally {
        Z = !1, K.current = u, qe(), Error.prepareStackTrace = i;
      }
      var D = e ? e.displayName || e.name : "", Se = D ? L(D) : "";
      return typeof e == "function" && U.set(e, Se), Se;
    }
    function Je(e, r, t) {
      return pe(e, !1);
    }
    function He(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function V(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return pe(e, He(e));
      if (typeof e == "string")
        return L(e);
      switch (e) {
        case g:
          return L("Suspense");
        case _:
          return L("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return Je(e.render);
          case v:
            return V(e.type, r, t);
          case E: {
            var a = e, i = a._payload, u = a._init;
            try {
              return V(u(i), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var q = Object.prototype.hasOwnProperty, he = {}, _e = P.ReactDebugCurrentFrame;
    function z(e) {
      if (e) {
        var r = e._owner, t = V(e.type, e._source, r ? r.type : null);
        _e.setExtraStackFrame(t);
      } else
        _e.setExtraStackFrame(null);
    }
    function Ke(e, r, t, a, i) {
      {
        var u = Function.call.bind(q);
        for (var s in e)
          if (u(e, s)) {
            var o = void 0;
            try {
              if (typeof e[s] != "function") {
                var k = Error((a || "React class") + ": " + t + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw k.name = "Invariant Violation", k;
              }
              o = e[s](r, s, a, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (b) {
              o = b;
            }
            o && !(o instanceof Error) && (z(i), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", a || "React class", t, s, typeof o), z(null)), o instanceof Error && !(o.message in he) && (he[o.message] = !0, z(i), y("Failed %s type: %s", t, o.message), z(null));
          }
      }
    }
    var Xe = Array.isArray;
    function Q(e) {
      return Xe(e);
    }
    function Ze(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Qe(e) {
      try {
        return ke(e), !1;
      } catch {
        return !0;
      }
    }
    function ke(e) {
      return "" + e;
    }
    function ge(e) {
      if (Qe(e))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ze(e)), ke(e);
    }
    var ye = P.ReactCurrentOwner, er = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Te, Ee;
    function rr(e) {
      if (q.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function tr(e) {
      if (q.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function ar(e, r) {
      typeof e.ref == "string" && ye.current;
    }
    function nr(e, r) {
      {
        var t = function() {
          Te || (Te = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function or(e, r) {
      {
        var t = function() {
          Ee || (Ee = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var sr = function(e, r, t, a, i, u, s) {
      var o = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: c,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: s,
        // Record the component responsible for creating this element.
        _owner: u
      };
      return o._store = {}, Object.defineProperty(o._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(o, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(o, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.freeze && (Object.freeze(o.props), Object.freeze(o)), o;
    };
    function ir(e, r, t, a, i) {
      {
        var u, s = {}, o = null, k = null;
        t !== void 0 && (ge(t), o = "" + t), tr(r) && (ge(r.key), o = "" + r.key), rr(r) && (k = r.ref, ar(r, i));
        for (u in r)
          q.call(r, u) && !er.hasOwnProperty(u) && (s[u] = r[u]);
        if (e && e.defaultProps) {
          var b = e.defaultProps;
          for (u in b)
            s[u] === void 0 && (s[u] = b[u]);
        }
        if (o || k) {
          var p = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          o && nr(s, p), k && or(s, p);
        }
        return sr(e, o, k, i, a, ye.current, s);
      }
    }
    var ee = P.ReactCurrentOwner, xe = P.ReactDebugCurrentFrame;
    function W(e) {
      if (e) {
        var r = e._owner, t = V(e.type, e._source, r ? r.type : null);
        xe.setExtraStackFrame(t);
      } else
        xe.setExtraStackFrame(null);
    }
    var re;
    re = !1;
    function te(e) {
      return typeof e == "object" && e !== null && e.$$typeof === c;
    }
    function Re() {
      {
        if (ee.current) {
          var e = S(ee.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function cr(e) {
      return "";
    }
    var je = {};
    function lr(e) {
      {
        var r = Re();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function we(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = lr(r);
        if (je[t])
          return;
        je[t] = !0;
        var a = "";
        e && e._owner && e._owner !== ee.current && (a = " It was passed a child from " + S(e._owner.type) + "."), W(e), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, a), W(null);
      }
    }
    function Fe(e, r) {
      {
        if (typeof e != "object")
          return;
        if (Q(e))
          for (var t = 0; t < e.length; t++) {
            var a = e[t];
            te(a) && we(a, r);
          }
        else if (te(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var i = A(e);
          if (typeof i == "function" && i !== e.entries)
            for (var u = i.call(e), s; !(s = u.next()).done; )
              te(s.value) && we(s.value, r);
        }
      }
    }
    function ur(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === v))
          t = r.propTypes;
        else
          return;
        if (t) {
          var a = S(r);
          Ke(t, e.props, "prop", a, e);
        } else if (r.PropTypes !== void 0 && !re) {
          re = !0;
          var i = S(r);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function fr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var a = r[t];
          if (a !== "children" && a !== "key") {
            W(e), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a), W(null);
            break;
          }
        }
        e.ref !== null && (W(e), y("Invalid attribute `ref` supplied to `React.Fragment`."), W(null));
      }
    }
    function Ce(e, r, t, a, i, u) {
      {
        var s = Le(e);
        if (!s) {
          var o = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (o += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var k = cr();
          k ? o += k : o += Re();
          var b;
          e === null ? b = "null" : Q(e) ? b = "array" : e !== void 0 && e.$$typeof === c ? (b = "<" + (S(e.type) || "Unknown") + " />", o = " Did you accidentally export a JSX literal instead of a component?") : b = typeof e, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", b, o);
        }
        var p = ir(e, r, t, i, u);
        if (p == null)
          return p;
        if (s) {
          var x = r.children;
          if (x !== void 0)
            if (a)
              if (Q(x)) {
                for (var D = 0; D < x.length; D++)
                  Fe(x[D], e);
                Object.freeze && Object.freeze(x);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Fe(x, e);
        }
        return e === h ? fr(p) : ur(p), p;
      }
    }
    function dr(e, r, t) {
      return Ce(e, r, t, !0);
    }
    function vr(e, r, t) {
      return Ce(e, r, t, !1);
    }
    var br = vr, mr = dr;
    B.Fragment = h, B.jsx = br, B.jsxs = mr;
  }()), B;
}
process.env.NODE_ENV === "production" ? oe.exports = gr() : oe.exports = yr();
var n = oe.exports;
const Tr = "_buttonWrap_m99s7_1", Er = "_button_m99s7_1", We = {
  buttonWrap: Tr,
  button: Er
}, xr = ({ onClick: l }) => /* @__PURE__ */ n.jsx("div", { className: We.buttonWrap, children: /* @__PURE__ */ n.jsx("button", { type: "button", "aria-label": "toggle feedback form", className: We.button, onClick: l, children: /* @__PURE__ */ n.jsx(Ae, { icon: "LightBulbBoldFilled", size: 20 }) }) }), Rr = "_wrap_u3ra9_1", jr = "_title_u3ra9_8", wr = "_gradesWrap_u3ra9_17", Fr = "_grade_u3ra9_17", Cr = "_emoji_u3ra9_46", Sr = "_label_u3ra9_51", N = {
  wrap: Rr,
  title: jr,
  gradesWrap: wr,
  grade: Fr,
  emoji: Cr,
  label: Sr
}, Or = () => {
  const { t: l } = J();
  return [
    {
      value: 1,
      emoji: "😠",
      label: l("Feedback.startGradesAwful")
    },
    {
      value: 2,
      emoji: "☹️",
      label: l("Feedback.startGradesBad")
    },
    {
      value: 3,
      emoji: "😐",
      label: l("Feedback.startGradesNeutral")
    },
    {
      value: 4,
      emoji: "🙂",
      label: l("Feedback.startGradesGood")
    },
    {
      value: 5,
      emoji: "😀",
      label: l("Feedback.startGradesGreat")
    }
  ];
}, Pr = ({ onGradeChange: l, title: c }) => {
  const { t: m } = J(), h = Or();
  return /* @__PURE__ */ n.jsxs("div", { className: N.wrap, children: [
    /* @__PURE__ */ n.jsx("h3", { className: N.title, children: c ?? m("Feedback.startTitle") }),
    /* @__PURE__ */ n.jsx("div", { className: N.gradesWrap, children: h == null ? void 0 : h.map((d, w) => /* @__PURE__ */ n.jsxs(
      "button",
      {
        "aria-label": d.label,
        className: N.grade,
        onClick: () => l(d),
        children: [
          /* @__PURE__ */ n.jsx("span", { className: N.emoji, children: d.emoji }),
          /* @__PURE__ */ n.jsx("span", { className: N.label, children: d.label })
        ]
      },
      w
    )) })
  ] });
}, Wr = "_wrap_ssai0_1", Dr = "_content_ssai0_9", Nr = "_title_ssai0_16", Ar = "_commentWrap_ssai0_25", $r = "_commentTitle_ssai0_30", Gr = "_commentInput_ssai0_39", Ir = "_commentCounter_ssai0_45", Br = "_buttonsWrap_ssai0_60", C = {
  wrap: Wr,
  content: Dr,
  title: Nr,
  commentWrap: Ar,
  commentTitle: $r,
  commentInput: Gr,
  commentCounter: Ir,
  buttonsWrap: Br
}, Yr = ({
  options: l,
  maxCommentLength: c = 100,
  answers: m,
  setAnswers: h,
  text: d,
  setText: w,
  handleBack: R,
  handleSubmit: T,
  translations: f = {}
}) => {
  const { t: g } = J(), _ = (v, E) => {
    h((j) => ({ ...j, [E]: v }));
  };
  return /* @__PURE__ */ n.jsxs("div", { className: C.wrap, children: [
    /* @__PURE__ */ n.jsxs("div", { className: C.content, children: [
      /* @__PURE__ */ n.jsx("h3", { className: C.title, children: f.checkboxesTitle ?? g("Feedback.checkboxesTitle") }),
      l.map((v, E) => /* @__PURE__ */ n.jsx(
        hr,
        {
          name: v.name,
          defaultChecked: m[v.name],
          onChange: (j) => _(j.target.checked, v.name),
          children: v.label
        },
        E
      )),
      /* @__PURE__ */ n.jsxs("div", { className: C.commentWrap, children: [
        /* @__PURE__ */ n.jsx("h4", { className: C.commentTitle, children: f.commentTitle ?? g("Feedback.commentTitle") }),
        /* @__PURE__ */ n.jsxs("label", { className: C.commentInput, children: [
          /* @__PURE__ */ n.jsx(
            _r,
            {
              value: d,
              placeholder: f.commentPlaceholder ?? g("Feedback.commentPlaceholder"),
              maxLength: c,
              onChange: (v) => w(v)
            }
          ),
          /* @__PURE__ */ n.jsxs("span", { className: C.commentCounter, children: [
            d.length,
            " / ",
            c
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ n.jsxs("div", { className: C.buttonsWrap, children: [
      /* @__PURE__ */ n.jsx(ne, { size: "large", color: "secondary", onClick: R, children: g(f.buttonTitleBack ?? "Feedback.buttonTitleBack") }),
      /* @__PURE__ */ n.jsx(ne, { size: "large", onClick: T, children: g(f.buttonTitleSubmit ?? "Feedback.buttonTitleSubmit") })
    ] })
  ] });
}, Mr = "_wrap_13myq_1", Lr = "_iconWrap_13myq_17", Ur = "_title_13myq_24", Vr = "_text_13myq_33", qr = "_buttonWrap_13myq_39", Y = {
  wrap: Mr,
  iconWrap: Lr,
  title: Ur,
  text: Vr,
  buttonWrap: qr
}, zr = ({ onDone: l, translations: c }) => {
  const { t: m } = J();
  return /* @__PURE__ */ n.jsxs("div", { className: Y.wrap, children: [
    /* @__PURE__ */ n.jsx("div", { className: Y.iconWrap, children: /* @__PURE__ */ n.jsx(Ae, { icon: "CheckInCircleBoldStroke", size: 56 }) }),
    /* @__PURE__ */ n.jsx("h3", { className: Y.title, children: (c == null ? void 0 : c.thanksTitle) ?? m("Feedback.thanksTitle") }),
    /* @__PURE__ */ n.jsx("div", { className: Y.text, children: m((c == null ? void 0 : c.thanksText) ?? "Feedback.thanksText") }),
    /* @__PURE__ */ n.jsx("div", { className: Y.buttonWrap, children: /* @__PURE__ */ n.jsx(ne, { size: "large", onClick: l, children: (c == null ? void 0 : c.buttonTitleDone) ?? m("Feedback.buttonTitleDone") }) })
  ] });
}, Jr = "_wrap_de90h_1", Hr = "_modal_de90h_19", Kr = "_content_de90h_23", ae = {
  wrap: Jr,
  modal: Hr,
  content: Kr
}, it = ({ testId: l, maxCommentLength: c, onSubmit: m, options: h, translations: d }) => {
  const [w, R] = G(!1), [T, f] = G("start"), [g, _] = G(), [v, E] = G({}), [j, M] = G(""), H = () => {
    m == null || m({
      answers: v,
      text: j,
      grade: g
    }), f("thanks");
  };
  return /* @__PURE__ */ n.jsxs("div", { className: ae.wrap, children: [
    /* @__PURE__ */ n.jsx(
      xr,
      {
        onClick: () => {
          R((A) => !A);
        }
      }
    ),
    /* @__PURE__ */ n.jsx(
      kr,
      {
        defaultClassName: ae.modal,
        isOpen: w,
        testId: l,
        onCloseButtonClick: () => R(!1),
        children: /* @__PURE__ */ n.jsxs("div", { className: ae.content, children: [
          T === "start" && /* @__PURE__ */ n.jsx(
            Pr,
            {
              title: d == null ? void 0 : d.startTitle,
              onGradeChange: (A) => {
                _(A), f("details");
              }
            }
          ),
          ["details", "thanks"].includes(T) && /* @__PURE__ */ n.jsx(
            Yr,
            {
              maxCommentLength: c,
              answers: v,
              setAnswers: E,
              text: j,
              setText: M,
              handleBack: () => {
                f("start");
              },
              options: h,
              handleSubmit: H,
              translations: d
            }
          ),
          T === "thanks" && /* @__PURE__ */ n.jsx(
            zr,
            {
              translations: d,
              onDone: () => {
                R(!1);
              }
            }
          )
        ] })
      }
    )
  ] });
}, Xr = {
  "Feedback.startTitle": "How would you rate the quality of the product",
  "Feedback.startGradesAwful": "Awful",
  "Feedback.startGradesBad": "Bad",
  "Feedback.startGradesNeutral": "Neutral",
  "Feedback.startGradesGood": "Good",
  "Feedback.startGradesGreat": "Great",
  "Feedback.checkboxesTitle": "Did you encounter any problems?",
  "Feedback.commentTitle": "Do you want to share something else with us? Write your ideas and thoughts",
  "Feedback.commentPlaceholder": "Optional comment",
  "Feedback.thanksTitle": "Thank you for your feedback.",
  "Feedback.thanksText": "Your feedback is highly valued and is used to improve our website and services, you can write us",
  "Feedback.buttonTitleBack": "Back",
  "Feedback.buttonTitleSubmit": "Submit feedback",
  "Feedback.buttonTitleDone": "Done"
}, Zr = {
  "Feedback.startTitle": "كيف تقيم جودة المنتج",
  "Feedback.startGradesAwful": "Awful",
  "Feedback.startGradesBad": "Bad",
  "Feedback.startGradesNeutral": "Neutral",
  "Feedback.startGradesGood": "Good",
  "Feedback.startGradesGreat": "Great",
  "Feedback.checkboxesTitle": "هل واجهت أي مشاكل؟",
  "Feedback.commentTitle": "هل تريد مشاركة شيء آخر معنا؟ اكتب أفكارك وخواطرك",
  "Feedback.commentPlaceholder": "تعليق اختياري",
  "Feedback.thanksTitle": "شكرًا لك على ملاحظاتك",
  "Feedback.thanksText": "ملاحظاتك قيّمة للغاية وتُستخدم لتحسين موقعنا وخدماتنا, يمكنك مراسلتنا",
  "Feedback.buttonTitleBack": "رجوع",
  "Feedback.buttonTitleSubmit": "إرسال التعليقات",
  "Feedback.buttonTitleDone": "تم"
}, Qr = (l, c, m) => l == null ? void 0 : l.addResourceBundle(c, "translation", m, !0, !0), De = (l, c) => c.forEach(({ key: m, bundle: h }) => Qr(l, m, h)), ct = (l, c) => function(h) {
  const d = c.i18Instance;
  return De(d, [{ key: "en-US", bundle: Xr }]), De(d, [{ key: "ar-AR", bundle: Zr }]), /* @__PURE__ */ n.jsx(pr, { i18n: d, children: /* @__PURE__ */ n.jsx(l, { ...h }) });
};
export {
  it as Feedback,
  Zr as arAR,
  ct as createFeedbackModuleEntry,
  Xr as enUS,
  Or as useFeedbackGrades
};
